import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loadPost, isPostLoaded } from "./postSlice";
import Comments from "../Comment/Comments";
import PostItem from "./PostItem";

const Post = ({ match }) => {
  const dispatch = useDispatch();

  const { id, subreddit } = match.params;
  const isLoaded = useSelector(isPostLoaded);

  useEffect(() => {
    dispatch(loadPost({ subreddit, id }));
  }, [dispatch, id, subreddit]);

  return (
    <div>
      {isLoaded && (
        <div className="post">
          <PostItem />
          <div>
            <h4>Comments</h4>
            <Comments />
          </div>
        </div>
      )}
    </div>
  );
};

export default Post;
